const formatCatalogueNumber = partNumber => {
  const catNumber = partNumber.toString()
  if (/^\d{7}$/g.test(catNumber)) {
    return `${catNumber.substr(0, 3)}/${catNumber.substr(3)}`
  }
  return catNumber
}

export default formatCatalogueNumber
